<div class="title-nav">
  <div class="all">
    <a routerLink="/biz" (click)="onNavigate('forum')" class="title-nav__item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
    <a routerLink="/biz/how-it-works" (click)="onNavigate('giveaway')" class="title-nav__item" routerLinkActive="active">How it Works</a>
  </div>
</div>
<router-outlet></router-outlet>
